<template>

	<v-row class="mt-4 pl-0 ml-n6 mb-n3" style="margin-right: -2px;">
		<v-col
			cols="12" xs="12" sm="12" md="4" lg="3" xl="2"
			class="px-3 pt-0 pb-0"
			v-for="(fieldType, i) in canUseFieldTypes" :key="i"
		>
			
			<v-checkbox
				class="pl-3 mt-2"
				:label="fieldType.name"
				v-model="fieldType.chosen"
			></v-checkbox>
			
		</v-col>
	</v-row>

</template>


<script>

// ----------------------------------------------------
//
//  Main script
//
// ----------------------------------------------------

import agile from "@/shift/agile";

export default
{
	name: 'ViewDynamicField',

	props:
	{
		id: { type: String },
		field: { type: Object },
		fieldTypes: { type: Array },
	},

	data: () =>
	({
		canUseFieldTypes: [],
	}),

	watch:
	{
		canUseFieldTypes:
		{
			deep: true,

			handler()
			{
				this.field.typeProperties.fieldTypesAvailable = [];

				for (let i = 0; i < this.canUseFieldTypes.length; i++)
				{
					if (this.canUseFieldTypes[i].chosen) this.field.typeProperties.fieldTypesAvailable.push(this.canUseFieldTypes[i]);
				}
			}
		}
	},

	computed:
	{
		agile()
		{
			return agile;
		},
		
		routeKey()
		{
			return this.$route.params.key;
		},
	},



	created()
	{
		// Populate checkboxes for available content types
		for (let i = 0; i < this.fieldTypes.length; i++)
		{
			if (this.fieldTypes[i].fieldType !== 'dynamicField') // Can't add dynamic field to dynamic field
			{
				const copy = Object.assign({}, this.fieldTypes[i]);
				
				// Get saved data, if the certain field type was chosen or not
				
				for (let j = 0; j < this.field.typeProperties.fieldTypesAvailable.length; j++)
				{
					if (copy.fieldType === this.field.typeProperties.fieldTypesAvailable[j].fieldType)
					{
						copy.chosen = true;
						break;
					}
				}
				
				this.canUseFieldTypes.push(copy);
			}
		}

		

	},

	mounted()
	{
		
	},

	methods:
	{
		
	}

}

</script>

